import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { isPresent } from '@mode/shared/util-js';
import {
  ReportParameterOptionsDomainState,
  getReportParameterOptionsLoading,
  getReportParameterOptions,
  getIsComplete,
} from './report-parameter-options/report-parameter-options.selectors';
import { filter, shareReplay } from 'rxjs/operators';
import { ReportDomain } from '@mode/shared/contract-common';
import * as ReportParameterActions from './report-parameter-options/report-parameter-options.actions';

@Injectable({
  providedIn: 'root',
})
export class ReportParameterOptionsFacade {
  constructor(private store: Store<ReportParameterOptionsDomainState>) {
    this.reportParameterOptions$ = store.select(getReportParameterOptions).pipe(filter(isPresent), shareReplay(1));
    this.reportParameterOptionsComplete$ = store.select(getIsComplete);
    this.reportParameterOptionsLoading$ = store
      .select(getReportParameterOptionsLoading)
      .pipe(filter(isPresent), shareReplay(1));
  }

  readonly reportParameterOptions$: Observable<ReportDomain.ReportRunFormFieldOptions[]>;
  readonly reportParameterOptionsLoading$: Observable<boolean>;
  readonly reportParameterOptionsComplete$: Observable<boolean>;

  loadReportParameterOptions(accountId: string, reportToken: string, reportRunToken: string) {
    this.store.dispatch(
      ReportParameterActions.loadReportParameterOptions({
        accountId,
        reportToken,
        reportRunToken,
      })
    );
  }
}
